import { Grid } from '@mui/material';
import React from 'react';
import { Cloner } from '../hooks/Cloner';

const Combiner = ({
  text,
  component,
  direction = 'row',
  justifyContent = 'flex-start',
  alignItems = 'center',
  separator = false,
  separatorComponent = false,
}) => {
  const arr = separator
    ? [...text]
        .map((e, i) => (i < text.length - 1 ? [e, separator] : [e]))
        .reduce((a, b) => a.concat(b))
    : [...text];

  const selection = (t, i) => {
    if (t !== separator)
      return (
        <Grid item key={i}>
          {Cloner(component, t)}
        </Grid>
      );
    if (separatorComponent)
      return (
        <Grid item key={i}>
          {Cloner(separatorComponent, t)}
        </Grid>
      );
    return (
      <Grid item key={i}>
        {separator}
      </Grid>
    );
  };
  return (
    <Grid
      container
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      {arr.map((t, i) => selection(t, i))}
    </Grid>
  );
};

export default Combiner;
